module.exports = __webpack_public_path__ + "img/11.d5d5b11f.jpg";